import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import Qs from 'qs'
import axios from 'axios'

import 'virtual:svg-icons-register'

import './App.scss'

import '../js/footer'
import '../js/header'
import '../js/contact-overlay'
import '../js/headline-text'
import '../js/max-lines'
import '../js/collapse'
import '../js/tabs'
import '../js/lightbox'
import '../js/swiper'
import '../js/popup-banner'
import '../js/carousel-cards'
import '../js/image-carousel'
import '../js/parallax'
import '../js/teaser-narrow-width'
import '../js/image-switch'
import '../js/image-slider'
import '../js/video'
import '../js/region-prompt'
import '../js/success'
import '../js/anchor-links'
import '../js/cookie-banner'

import { QueryParamProvider } from 'use-query-params'
import { WindowHistoryAdapter } from 'use-query-params/adapters/window'
import { saveReferrer } from '../js/components/forms/helpers'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

saveReferrer()

axios.defaults.paramsSerializer = (params) =>
  Qs.stringify(params, { arrayFormat: 'repeat' })

const reactComponents = [
  {
    selector: '#form-rent-enquiry-simple',
    loader: () => import('../js/components/forms/rent-enquiry-simple/index'),
  },
  {
    selector: '#form-general-enquiry',
    loader: () => import('../js/components/forms/general-enquiry/index'),
  },
  {
    selector: '#form-appointment-scheduling',
    loader: () => import('../js/components/forms/appointment-scheduling/index'),
  },
  {
    selector: '#form-internal-enquiry',
    loader: () => import('../js/components/forms/internal-enquiry/index'),
  },
  {
    selector: '#form-offer-enquiry',
    loader: () => import('../js/components/forms/offer-enquiry/index'),
    props: { type: 'rental' },
  },
  {
    selector: '#form-offer-purchase',
    loader: () => import('../js/components/forms/offer-enquiry/index'),
    props: { type: 'purchase' },
  },
  {
    selector: '#form-application-areas',
    loader: () => import('../js/components/forms/application-area/index'),
  },
  {
    selector: '#form-rent-enquiry-complex',
    loader: () => import('../js/components/forms/rent-enquiry-complex/index'),
  },
  {
    selector: '#form-reference-project',
    loader: () => import('../js/components/forms/reference-project/index'),
  },
  {
    selector: '#form-planning-sample',
    loader: () => import('../js/components/forms/planning-sample/index'),
  },
  {
    selector: '#s-form-abo',
    loader: () => import('../js/components/standard-forms/abo'),
  },
  {
    selector: '#s-form-repurchase',
    loader: () => import('../js/components/standard-forms/repurchase'),
  },
  {
    selector: '#s-form-defects',
    loader: () => import('../js/components/standard-forms/defects'),
  },
  {
    selector: '#s-form-subcontractor',
    loader: () => import('../js/components/standard-forms/subcontractor'),
  },
  {
    selector: '#s-form-photo-contest',
    loader: () => import('../js/components/standard-forms/photo-contest'),
  },
  {
    selector: '#s-form-newsletter',
    loader: () => import('../js/components/standard-forms/newsletter'),
  },
  {
    selector: '#s-form-return',
    loader: () => import('../js/components/standard-forms/return'),
  },
  {
    selector: '#s-form-callback',
    loader: () => import('../js/components/standard-forms/callback'),
  },
  {
    selector: '#s-form-partner',
    loader: () => import('../js/components/standard-forms/partner'),
  },
  {
    selector: '#s-form-employee-application',
    loader: () => import('../js/components/standard-forms/employee-application'),
  },
  {
    selector: '#s-form-general-contact',
    loader: () => import('../js/components/standard-forms/general-contact-form'),
  },
  {
    selector: '#stream',
    loader: () => import('../js/components/stream/index'),
  },
  {
    selector: '#reference-projects-overview',
    loader: () => import('../js/components/reference-projects/overview'),
  },
  {
    selector: '#planning-samples',
    loader: () => import('../js/components/planning-samples/overview'),
  },
  {
    selector: '.reference-slider-comp',
    loader: () => import('../js/components/reference-projects/slider'),
  },
  {
    selector: '#offer-overview',
    loader: () => import('../js/components/offers/overview'),
  },
  {
    selector: '#news-overview',
    loader: () => import('../js/components/news/index'),
  },
  {
    selector: '.offers-slider-comp',
    loader: () => import('../js/components/offers/slider'),
  },
  {
    selector: '.Search',
    loader: () => import('../js/components/search'),
  },
  {
    selector: '#depot-map',
    loader: () => import('../js/components/depot-map/depot-map'),
    props: { isDepotMap: true },
  },
  {
    selector: '#showroom-map',
    loader: () => import('../js/components/depot-map/depot-map'),
    props: { isDepotMap: false },
  },
  {
    selector: '#image-swiper',
    loader: () => import('../js/components/offers/image-swiper'),
  },
  {
    selector: '[data-success-page-contact]',
    loader: () => import('../js/components/forms/common/success-contact'),
  },
]

reactComponents.forEach((reactComponent) => {
  const ReactComponent = React.lazy(reactComponent.loader)
  const props = reactComponent.props || {}
  const queryClient = new QueryClient()

  document.querySelectorAll(reactComponent.selector).forEach((element) => {
    const combinedProps = { ...props, ...element.dataset }
    const root = createRoot(element)
    root.render(
      <QueryClientProvider client={queryClient}>
        <QueryParamProvider adapter={WindowHistoryAdapter}>
          <Suspense fallback={<div></div>}>
            {/* @ts-ignore */}
            <ReactComponent {...combinedProps} />
          </Suspense>
        </QueryParamProvider>
      </QueryClientProvider>,
    )
  })
})
